import { quizEditorActionTypes } from './Constants';

export function getQuizQuestionsPanel(params) {
	return {
		type: quizEditorActionTypes.GET_QUIZ_QUESTIONS_PANEL,
		payload: { params },
	};
}

export function getQuizQuestionsPanelSuccess(data) {
	return {
		type: quizEditorActionTypes.GET_QUIZ_QUESTIONS_PANEL_SUCCESS,
		payload: { data },
	};
}

export function getQuizQuestionsPanelError() {
	return {
		type: quizEditorActionTypes.GET_QUIZ_QUESTIONS_PANEL_ERROR,
	};
}

export function changeQuestionPosition(data) {
	return {
		type: quizEditorActionTypes.CHANGE_QUESTION_POSITION,
		payload: { data },
	};
}

export function updateQuestionsList(data) {
	return {
		type: quizEditorActionTypes.UPDATE_QUIZ_QUESTIONS_LIST,
		payload: { data },
	};
}

export function createQuizQuestion(data, callback) {
	return {
		type: quizEditorActionTypes.CREATE_QUIZ_QUESTION_REQUEST,
		payload: { data, callback },
	};
}

export function createQuizQuestionSuccess(data) {
	return {
		type: quizEditorActionTypes.CREATE_QUIZ_QUESTION_SUCCESS,
		payload: { data },
	};
}

export function createQuizQuestionError() {
	return {
		type: quizEditorActionTypes.CREATE_QUIZ_QUESTION_ERROR,
	};
}

export function getQuizQuestion(id, blockUpdate) {
	return {
		type: quizEditorActionTypes.GET_QUIZ_QUESTION_REQUEST,
		payload: { id, blockUpdate },
	};
}

export function getQuizQuestionSuccess() {
	return {
		type: quizEditorActionTypes.GET_QUIZ_QUESTION_SUCCESS,
	};
}

export function getQuizQuestionError() {
	return {
		type: quizEditorActionTypes.GET_QUIZ_QUESTION_ERROR,
	};
}

export function manageQuizQuestion(id, type, index, callback) {
	return {
		type: quizEditorActionTypes.MANAGE_QUIZ_QUESTION_REQUEST,
		payload: { id, type, index, callback },
	};
}

export function manageQuizQuestionSuccess() {
	return {
		type: quizEditorActionTypes.MANAGE_QUIZ_QUESTION_SUCCESS,
	};
}

export function manageQuizQuestionError() {
	return {
		type: quizEditorActionTypes.MANAGE_QUIZ_QUESTION_ERROR,
	};
}

export function updateQuizQuestion(id, formData, index, updateSideEffect) {
	return {
		type: quizEditorActionTypes.UPDATE_QUIZ_QUESTION_REQUEST,
		payload: { id, formData, index, updateSideEffect },
	};
}

export function updateQuizQuestionSuccess(data) {
	return {
		type: quizEditorActionTypes.UPDATE_QUIZ_QUESTION_SUCCESS,
		payload: { data },
	};
}

export function updateQuizQuestionError() {
	return {
		type: quizEditorActionTypes.UPDATE_QUIZ_QUESTION_ERROR,
	};
}

export function previewQuiz(quizId, stage, questionId, streamId, type) {
	return {
		type: quizEditorActionTypes.PREVIEW_QUIZ_REQUEST,
		payload: { quizId, stage, questionId, streamId, type },
	};
}

export function previewQuizSuccess(data) {
	return {
		type: quizEditorActionTypes.PREVIEW_QUIZ_SUCCESS,
		payload: { data },
	};
}

export function publishQuiz(params) {
	return {
		type: quizEditorActionTypes.PUBLISH_QUIZ_REQUEST,
		payload: { params },
	};
}

export function publishQuizSuccess(data) {
	return {
		type: quizEditorActionTypes.PUBLISH_QUIZ_SUCCESS,
		payload: { data },
	};
}

export function publishQuizError() {
	return {
		type: quizEditorActionTypes.PUBLISH_QUIZ_ERROR,
	};
}

export function selectQuestion(data) {
	return {
		type: quizEditorActionTypes.SELECT_QUIZ_QUESTION,
		payload: { data },
	};
}

export function setUpdateTime(data) {
	return {
		type: quizEditorActionTypes.SET_QUIZ_UPDATE_TIME,
		payload: { data },
	};
}

export function changeQuestionDataLoadProgress(data) {
	return {
		type: quizEditorActionTypes.CHANGE_QUESTION_DATA_PROGRESS,
		payload: { data },
	};
}

export function clearState() {
	return {
		type: quizEditorActionTypes.CLEAR_QUIZ_EDITOR,
	};
}
